import { render, staticRenderFns } from "./VehicleManage.vue?vue&type=template&id=8ce56280&scoped=true"
import script from "./VehicleManage.vue?vue&type=script&lang=js"
export * from "./VehicleManage.vue?vue&type=script&lang=js"
import style0 from "./VehicleManage.vue?vue&type=style&index=0&id=8ce56280&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce56280",
  null
  
)

export default component.exports